"use client";

import React from "react";

interface ChatButtonProps {
  five9ConfigId?: string;
  callbackFunction?: () => void;
  expanded?: boolean;
  title?: string;
  noPadding?: boolean;
  extraClasses?: string;
  withoutIcon?: boolean;
  buttonStyle?: boolean;
  display?: boolean;
}

const ChatButton: React.FC<ChatButtonProps> = ({
  five9ConfigId,
  callbackFunction,
  expanded,
  title,
  noPadding,
  extraClasses,
  withoutIcon,
  buttonStyle,
  display,
}) => {
  const showFive9Chat = () => {
    const clickDiv = document.getElementById("five9OpenChatButton");
    if (clickDiv) {
      clickDiv.click();
    } else if (callbackFunction) {
      callbackFunction();
    } else {
      console.log("five9OpenChatButton not found.");
    }
  };

  const renderChatButton = (onClickHandler: () => void) => {
    const styles = {
      padding: noPadding ? "unset" : "11px",
      display: display ? "unset" : "inline-block",
    };
    const className = extraClasses ? "chatBtnClicker " + extraClasses : "chatBtnClicker";

    return (
      <>
        {buttonStyle ? (
          <button onClick={showFive9Chat}>{title || "Live Chat"}</button>
        ) : (
          <a href="#" onClick={onClickHandler} className={className} style={styles}>
            {!withoutIcon && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="livechat-bubble-svg"
                style={{
                  fill: "#000d74",
                  color: "#000d74",
                  margin: "0 5px 4px",
                  height: "20px",
                  width: "auto",
                  verticalAlign: "middle",
                }}
                viewBox="0 0 68.33 59.22"
              >
                <path d="M57.54 37.19c.38 2.68 2.1 8.61 8.5 15.49a1.63 1.63 0 0 1 .38 1.63 1.11 1.11 0 0 1-1 1 18.37 18.37 0 0 1-2.87.19c-3.91 0-11-.77-19.87-4.88a33.9 33.9 0 0 1-12.24 2.2c-16.15 0-29.25-11.18-29.25-25.14S14.24 2.5 30.39 2.5s29.25 11.28 29.25 25.23a22.55 22.55 0 0 1-2.1 9.46Z" />
              </svg>
            )}
            {expanded && <span>{title || "Live Chat"}</span>}
          </a>
        )}
      </>
    );
  };

  if (five9ConfigId) {
    return renderChatButton(showFive9Chat);
  }

  return null;
};

export default ChatButton;
